<script setup>
import { defineEmits } from "vue";
import Create from "./Create.vue";
import fetchData from "@/utils/fetchData";

const emit = defineEmits(["reload"]);

const create = async ({ text }) => {
  await fetchData("createCampaign", { name: text });
  emit("reload");
};
</script>

<template>
  <div class="mb-5 max-w-md">
    <Create
      placeholder="Name a new campaign, e.g. University flyer"
      id="new-campaign"
      @create="create($event)"
    />
  </div>
</template>
